import React from "react"

const Multi2 = () => {
  return (
    <div className="subService">
      <h3>
        Quelle est la surface à revêtir?
        <span className="obg"> *</span>
      </h3>
      <select name="surafe-facade" required>
        <option value="Moins de 10 m²">Moins de 10 m²</option>
        <option value="Entre 10 et 50 m²">Entre 10 et 50 m²</option>
        <option value="Entre 50 et 100 m²">Entre 50 et 100 m²</option>
        <option value="Plus de 100 m²">Plus de 100 m²</option>
      </select>
      <h3>
        Voulez-vous aussi faire isoler les murs?
        <span className="obg"> *</span>
      </h3>
      <select name="isoler-mur" required>
        <option value="oui / peut-être">oui / peut-être</option>
        <option value="non">non</option>
      </select>
      <h3>
        Par quel(s) type(s) de bois êtes-vous intéressé?
        <span className="obg"> *</span>
      </h3>
      <select name="type-bois" required>
        <option value="bois dur (cèdre, padouk, chêne, iroko,...)">
          bois dur (cèdre, padouk, chêne, iroko,...)
        </option>
        <option value="bois tendre préservé (thermowood, oregon, mélèze,...)">
          bois tendre préservé (thermowood, oregon, mélèze,...)
        </option>
      </select>
    </div>
  )
}

export default Multi2
